import { useMocks } from '../../shared/env';
import type { TaxPaymentSettingsGateway } from './TaxPaymentSettingsGateway';
import { HttpTaxPaymentSettingsGateway } from './HttpTaxPaymentSettingsGateway';
import { MockTaxPaymentSettingsGateway } from './MockTaxPaymentSettingsGateway';

export const taxPaymentSettingsGateway: TaxPaymentSettingsGateway = useMocks
  ? new MockTaxPaymentSettingsGateway()
  : new HttpTaxPaymentSettingsGateway();
export type { TaxPaymentSettingsGateway } from './TaxPaymentSettingsGateway';
